import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

const mutateAddQualityChecklist = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${QUALITY_CHECKLIST_API}`, data);
};

const useAddQualityChecklistMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddQualityChecklist,
    ...queryParams,
  });

export default useAddQualityChecklistMutation;
